import { Component, Input, Output, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BaseTableColumn } from '../../models/app-models/BaseTableColumn.model';
import { MatTableModule } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
@Component({
  selector: 'app-editable-table',
  templateUrl: './editable-table.component.html',
  styleUrls: ['./editable-table.component.scss']
})
export class EditableTableComponent<T> {
  @Input() data!: T[];
  @Input() columns: BaseTableColumn<T>[] = [];
  @Input() noDataMessage: string = "You have no record for this budget type.";
  @Input() editCallbackFunction: (args: any) => void = () => { };
  @Input() deleteCallbackFunction: (args: any) => void = () => { };
  dataSource: MatTableDataSource<T> = new MatTableDataSource<T>();
  displayedColumns: string[] = []
  initialSelection = [];
  selection: SelectionModel<T> = new SelectionModel<T>(false, this.initialSelection);
  constructor() {
  }
  ngOnInit() {
    this.displayedColumns = this.columns.map(c => c.columnDef);
    this.dataSource = new MatTableDataSource<T>(this.data);
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'].currentValue) {
      this.dataSource = new MatTableDataSource<T>(changes['data'].currentValue);
    }
  }
  editItem(row: any) {
    this.editCallbackFunction(row);
  }
  deleteItem(row: any) {
    this.deleteCallbackFunction(row)
  }
}
